import React from 'react'
import UserAvatar from './UI/UserAvatar'
import ActionButton from './UI/ActionButton'

const ProfileBanner = ({ user, onNavigate }) => {
  const actionButtons = [
    {
      onClick: () => onNavigate('/passport'),
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      ),
      text: 'Event Passport',
      gradientColors: ['var(--theme-accent)', 'var(--theme-primary)']
    },
    {
      onClick: () => onNavigate('/newEvent'),
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
      ),
      text: 'New Event',
      gradientColors: ['var(--theme-primary)', 'var(--theme-secondary)']
    },
    {
      onClick: () => onNavigate('/add-stamp'),
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      text: 'Add Stamps',
      gradientColors: ['var(--theme-secondary)', 'var(--theme-accent)']
    },
    {
      onClick: () => onNavigate('/add-friend'),
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
        </svg>
      ),
      text: 'Friends',
      gradientColors: ['var(--theme-accent)', 'var(--theme-primary)']
    }
  ];

  const getWelcomeMessage = () => {
    const displayName = user?.profileSettings?.raveName || user?.username || user?.firstName;
    if (displayName) return `Welcome back, ${displayName}!`;
    return 'Welcome Back!';
  };

  return (
    <div className="mb-6">
      <div className="flex items-center gap-4 mb-6">
        <UserAvatar size="2xl" className="shadow-xl" />
        <div>
          <h1 className="text-2xl font-bold mb-1" style={{color: 'var(--theme-text-primary)'}}>
            {getWelcomeMessage()}
          </h1>
          <p className="text-base" style={{color: 'var(--theme-text-secondary)'}}>
            Track your events and create lasting memories
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {actionButtons.map((button, index) => (
          <ActionButton
            key={index}
            onClick={button.onClick}
            icon={button.icon}
            text={button.text}
            gradientColors={button.gradientColors}
          />
        ))}
      </div>
    </div>
  );
};

export default ProfileBanner